<template>
  <v-card
    v-if="visible"
    ref="booking_vehicle_type"
    id="booking_vehicle_type"
    elevation="0"
    class="mx-auto secondary rounded-0"
  >
    <CardHeader
      title="4. HVORDAN?"
      :icon="!displayVehicleType ? openDisplayIcon : closeDisplayIcon"
      @iconClicked="displayVehicleType = !displayVehicleType"
      marginBottom="0"
    />
    <v-flex d-flex v-if="displayVehicleType">
      <v-layout wrap>
        <v-flex
          :md3="vehicleTypes.length == 4"
          :md4="vehicleTypes.length == 3"
          :md6="vehicleTypes.length == 2"
          :md12="vehicleTypes.length == 1"
          v-for="item in vehicleTypes"
          :key="item.external_key"
        >
          <v-tooltip bottom color="info" :disabled="$vuetify.breakpoint.mobile">
            <template v-slot:activator="{ on, attrs }">
              <v-card
                :color="
                  item.external_key === selected ? '#e7e8ee' : 'secondary'
                "
                :style="
                  item.external_key === selected
                    ? 'border: 2px solid #fcbf00 !important'
                    : 'border: 2px solid #f1f3f8 !important'
                "
                height="100%"
                v-on="on"
                v-bind="attrs"
                elevation="0"
                class="rounded-0"
                @click="selectVehicleType(item)"
                @keydown="
                  e => {
                    keyDownHandler(e, item);
                  }
                "
              >
                <v-row no-gutters>
                  <v-col
                    :class="
                      $vuetify.breakpoint.smAndDown
                        ? 'pt-5 text-center'
                        : 'pt-13 pb-8 text-center'
                    "
                  >
                    <v-img
                      :src="require('../assets/images/' + item.icon)"
                      class="ma-auto"
                      contain
                      max-height="60px"
                    ></v-img>
                    <v-row no-gutters class="pt-5">
                      <v-col class="px-2 py-0 ma-0 font-weight-bold">
                        {{ item.name }}
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col class="px-2 py-0 ma-0">
                        {{ item.loading_width }} x {{ item.loading_height }} x
                        {{ item.loading_length }}
                        cm
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col class="px-2 pt-0 pb-2 ma-0">
                        (max {{ item.max_weight }} kg)
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <div v-if="$vuetify.breakpoint.mobile" class="pb-2">
                  <v-row no-gutters>
                    <v-col class="px-2 py-0 ma-0">
                      Pallepladser: {{ item.pallet_spaces }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="item.lift != null">
                    <v-col class="px-2 py-0 ma-0">
                      Har lift (max {{ item.lift.max_weight }} kg)
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="item.pipes != null">
                    <v-col class="px-2 py-0 ma-0">
                      Kan køre med rør (max {{ item.pipes.max_length }} cm)
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </template>

            <v-row no-gutters>
              <v-col class="pa-0 ma-0">
                Pallepladser: {{ item.pallet_spaces }}
              </v-col>
            </v-row>
            <v-row no-gutters v-if="item.lift != null">
              <v-col class="pa-0 ma-0">
                Har lift (max {{ item.lift.max_weight }} kg)
              </v-col>
            </v-row>
            <v-row no-gutters v-if="item.pipes != null">
              <v-col class="pa-0 ma-0">
                Kan køre med rør (max {{ item.pipes.max_length }} cm)
              </v-col>
            </v-row>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
import CardHeader from "@/components/templates/CardHeader.vue";
import { tools } from "../helpers";
import { dictionary } from "../helpers";

export default {
  name: "VehicleType",
  components: { CardHeader },
  data: () => ({
    openDisplayIcon: dictionary.mdi.open,
    closeDisplayIcon: dictionary.mdi.close
  }),
  computed: {
    visible: {
      get() {
        return (
          this.$store.state.booking.data.account &&
          this.$store.state.booking.data.pickup.address.address &&
          this.$store.state.booking.data.pickup.address.name &&
          this.$store.state.booking.data.delivery.address.address &&
          this.$store.state.booking.data.delivery.address.name &&
          this.goodsValid()
        );
      }
    },
    displayVehicleType: {
      get() {
        return this.$store.state.booking.display_vehicle_type;
      },
      set(value) {
        this.$store.state.booking.display_vehicle_type = value;
      }
    },
    vehicleTypes() {
      let vehicleTypes = [];
      this.$store.getters["user/vehicleTypes"].forEach(vehicleType => {
        if (this.validateVehicleType(vehicleType)) {
          vehicleTypes.push(vehicleType);
        }
      });

      if (
        this.$store.state.booking.data.vehicle_type &&
        this.$store.state.booking.data.vehicle_type.external_key
      ) {
        let selectedVehicleTypeAvailable = false;
        vehicleTypes.forEach(vehicleType => {
          if (
            vehicleType &&
            vehicleType.external_key ==
              this.$store.state.booking.data.vehicle_type.external_key
          ) {
            selectedVehicleTypeAvailable = true;
          }
        });

        if (!selectedVehicleTypeAvailable) {
          this.selectVehicleType(null);
        }
      }

      return vehicleTypes;
      // return this.$store.getters["user/vehicleTypes"];
    },
    selected() {
      return this.$store.state.booking.data.vehicle_type.external_key;
    }
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs.booking_vehicle_type);
          });
        }
      }
    }
  },
  methods: {
    selectVehicleType(vehicleType) {
      this.$store.commit("booking/updateVehicleType", vehicleType);
      this.calculatePrice();
    },
    async calculatePrice() {
      await this.$store.dispatch("booking/calculatePrice");
    },
    goodsValid() {
      return (
        this.$store.state.booking.data.goods &&
        this.$store.state.booking.data.goods[0] &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].cll) > 0 &&
        this.$store.state.booking.data.goods[0].description.length > 0 &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].weight) > 0
      );
    },
    validateVehicleType(vehicleType) {
      if (vehicleType) {
        //check for overload
        let maxWeight = tools.parseDouble(0.0);
        let totalWeight = tools.parseDouble(0.0);
        let totalPalletSpaces = tools.parseDouble(0.0);
        let hasPipes = false;
        let pipesLength = 0;
        this.$store.state.booking.data.goods.forEach(goodsItem => {
          if (goodsItem) {
            maxWeight =
              tools.parseDouble(goodsItem.weight) > maxWeight
                ? tools.parseDouble(goodsItem.weight)
                : maxWeight;
            totalWeight += tools.parseDouble(goodsItem.weight);
            totalPalletSpaces += tools.parseDouble(goodsItem.pallet_spaces);
            if (goodsItem.pipes) {
              hasPipes = true;
              pipesLength = Math.max(pipesLength, goodsItem.length);
            }
          }
        });

        if (tools.parseDouble(vehicleType.max_weight) < totalWeight) {
          return false;
        }
        if (
          vehicleType.lift &&
          tools.parseDouble(vehicleType.lift.max_weight) < maxWeight
        ) {
          return false;
        }
        if (tools.parseDouble(vehicleType.pallet_spaces) < totalPalletSpaces) {
          return false;
        }
        if (!vehicleType.pipes && hasPipes) {
          return false;
        }
        if (
          vehicleType.pipes &&
          hasPipes &&
          vehicleType.pipes.max_length < pipesLength
        ) {
          return false;
        }
      }
      return true;
    },
    keyDownHandler(e, vehicle) {
      if (e && vehicle) {
        const key = window.event ? e.keyCode : e.which;

        // enter or space
        if (key === 13 || key === 32) {
          this.selectVehicleType(vehicle);
        }
      }
    }
  }
};
</script>
